/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import { Accordion as MDAccordion, AccordionProps } from "@mui/material";
import { forwardRef } from "react";

/**
 * Wrapper component for Material-UI Accordion.
 * Provides expandable/collapsible content sections.
 * 
 * @param props - Accordion properties (expanded, onChange, etc.)
 * @returns Accordion component for collapsible content
 */
const Accordion = forwardRef<HTMLDivElement, AccordionProps>((props, ref) => {
  return <MDAccordion {...props} ref={ref} />;
});

export default Accordion;
